import React from "react";
import fbIcon from '../../../assets/icons/social/fb-share.svg';
import twitterIcon from '../../../assets/icons/social/twitter-share.svg';
import linkedinIcon from '../../../assets/icons/social/linkedin-share.svg';
import gplusIcon from '../../../assets/icons/social/gplus-share.svg';
import whatsappIcon from '../../../assets/icons/social/whatsapp-share.svg';
import assetify from '@quintype/framework/assetify';

export function getSocialCardsTemplate({fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl}) {
  return (
    <ul className="social-share-icons">
      <li className="social-share-icon">
        <a href={fbUrl} target="_blank">
          <img src={assetify(fbIcon)} alt="fb icon"/>
        </a>
      </li>
      <li className="social-share-icon">
        <a href={twitterUrl} target="_blank">
          <img src={assetify(twitterIcon)} alt="twitter icon"/>
        </a>
      </li>
      <li className="social-share-icon">
        <a href={gplusUrl} target="_blank">
          <img src={assetify(gplusIcon)} alt="gplus icon"/>
        </a>
      </li>
      <li className="social-share-icon">
        <a href={linkedinUrl} target="_blank">
          <img src={assetify(linkedinIcon)} alt="linkedin icon"/>
        </a>
      </li>
      <li className="social-share-icon">
        <a href={whatsappUrl} target="_blank">
          <img src={assetify(whatsappIcon)} alt="whatsapp share"/>
        </a>
      </li>
    </ul>
  );
}